var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55556 32H28.4444C30.4053 32 32 30.4053 32 28.4444V3.55556C32 1.59467 30.4053 0 28.4444 0H3.55556C1.59467 0 0 1.59467 0 3.55556V14.224H12.4409V7.11111L23.1076 16L12.4409 24.8889V17.7796H0V28.4444C0 30.4053 1.59467 32 3.55556 32Z",
    fill: "#F74542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector4.8d9280605d418e813a13d10f1ebe01d2.svg";
export { ForwardRef as ReactComponent };